<template>
  <div class="percentage-bar" :style="{ background: `rgba(${rgbColor}, 0.25)` }">
    <div class="percentage-bar-inner" :style="{ width: barWidth, background: color }"></div>
  </div>
</template>

<script>
import { hex2RGB } from '../helpers'

export default {
  name: 'percentage-bar',
  props: {
    percentage: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      default: '#0C99D9',
      validator: value => {
        // Validate #000 / #000000 hex codes
        return /^#(?:[a-f0-9]{3}){1,2}$/i.test(value)
      }
    }
  },
  data () {
    return {
      rgbColor: hex2RGB(this.color).join(',')
    }
  },
  computed: {
    barWidth: function () { return `${this.percentage}%` }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .percentage-bar {
    height: 12px;
    position: relative;
    overflow: hidden;
    border-radius: 2px;
  }

  .percentage-bar-inner {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    transition: all $animation-timing-fn;
    width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/PercentageBar.vue